import React from "react";

const Testimonials = () => {
  return (
    <div>
      <h1>Hello this testi page</h1>
    </div>
  );
};

export default Testimonials;
